export const AppliedIncentivesNode = 'appliedIncentives';
export const AppliedIncentiveIdsNode = 'appliedIncentiveIds';
export const SelectedIncentivesNode = 'selectedIncentives';
export const ManualIncentivesNode = 'manualIncentives';
